import { ButtonBase, Tooltip } from '@fullstory/components';
import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import ThumbsUp from './assets/thumbs-up.svg';
import ThumbsUpFilled from './assets/thumbs-up-filled.svg';
import css from './index.module.scss';

export interface ThumbToggleProps {
  testId?: string;
  direction?: 'up' | 'down';
  toggled: boolean;
  title: string;
  onToggle: (val: boolean) => void;
  disabled?: boolean;
}

export const ThumbToggle: React.FC<ThumbToggleProps> = ({
  testId,
  direction = 'up',
  title,
  toggled,
  onToggle,
  disabled,
  ...rest
}) => (
  <Tooltip
    data-component="ThumbToggle"
    placement="bottom"
    tooltipContent={title}
    showDelay={300}
    persistDelay={0}
    offset={16}
    compact
    interactive={false}
    className={css.thumbToggleTooltip}
  >
    <ButtonBase
      disabled={disabled}
      aria-label={title}
      {...rest}
      testId={testId}
      onClick={() => {
        onToggle(!toggled);
      }}
      className={classNames(css.thumbToggle, {
        [css.toggled]: toggled,
        [css.thumbsDown]: direction === 'down',
      })}
      aria-selected={toggled}
    >
      {toggled ? <ThumbsUpFilled /> : <ThumbsUp />}
    </ButtonBase>
  </Tooltip>
);
